import type { i18n as I18nInstance } from 'i18next';

/** English indefinite article for a noun: "an electrician", "a plumber". */
export const withIndefiniteArticle = (value: unknown): string => {
  const text = String(value ?? '');
  return `${/^[aeiou]/i.test(text) ? 'an' : 'a'} ${text}`;
};

/**
 * Formatters the copy can use as {{value, name}}. English quiz copy writes
 * "As {{trade, indefinite}}" so a trade name gets the right article.
 */
export function addFormatters(instance: I18nInstance): void {
  instance.services.formatter?.add('indefinite', (value) => withIndefiniteArticle(value));
}

/**
 * The same interpolation for copy filled outside i18next (share images):
 * {{name}} and {{name, indefinite}}.
 */
export const fillCopy = (text: string, vars: Record<string, string>): string =>
  text.replace(/\{\{\s*(\w+)\s*(?:,\s*(\w+)\s*)?\}\}/g, (_, key: string, format?: string) => {
    const value = vars[key] ?? '';
    return format === 'indefinite' ? withIndefiniteArticle(value) : value;
  });
